import { ClerkProvider } from "@clerk/clerk-react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.css";

const clerkPk = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

if (!clerkPk) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <main style={{ fontFamily: "system-ui", padding: "2rem", maxWidth: "40rem" }}>
        <h1>SurgeDial</h1>
        <p>
          Customer / agent UI shell for <strong>wildix.dialler.app</strong>. Set <code>VITE_CLERK_PUBLISHABLE_KEY</code>{" "}
          (see README — Phase 1).
        </p>
      </main>
    </React.StrictMode>,
  );
} else {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ClerkProvider publishableKey={clerkPk}>
        <App />
      </ClerkProvider>
    </React.StrictMode>,
  );
}
